import React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useUserDetails } from '../../../services/auth/auth';
import { Arrow } from '../../shared/icons/arrow';

import styles from './userDetails.module.css';
import { ProfilePhoto } from '../../shared/profilePhoto/profilePhoto';
import { UserPulldown } from '../../feature/users/userPulldown';
import { Api, pathJoin } from '../../../services/api';


export const UserDetails = () => {
    const details = useUserDetails();

    const [down, setDown] = useState(false);

    const pulldown = useRef(null);
    const button = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const path = event.path || event.composedPath();

            if (!pulldown.current && !button.current) return;

            for (let i = 0; i < path.length; i++) {
                if (path[i] === pulldown.current || path[i] === button.current) {
                    return;
                }
            }

            setDown(false);
        }
        document.addEventListener('pointerdown', handleClickOutside);
        return () => {
            document.removeEventListener('pointerdown', handleClickOutside);
        };
    }, [pulldown, button]);

    return (
        <section className={styles.UserDetails}>
            <div ref={button} className={styles.Button} onClick={() => setDown(!down)}>
                <div>
                    Hello {details?.name ?? ''}
                </div>
                <div className={styles.ProfileIcon}>
                    <ProfilePhoto userId={details?.localAccountId} hasProfilePhoto={true} />
                </div>
                <Arrow direction={down ? 'up' : 'down'}/>
            </div>

            <div ref={pulldown} className={styles.PullDown + ' card' + (down ? ' ' + styles.Down : '')}>
                <UserPulldown setDown={setDown} />
            </div>
        </section>
        
    )
}